export const LOCATION_SUMMARY_REFRESH_COOLDOWN_MS = 9_000_000;

export function isRefreshAvailable(aggregatedAt: string, now: Date): boolean {
  const aggregatedAtMs = Date.parse(aggregatedAt);
  if (Number.isNaN(aggregatedAtMs)) {
    return true;
  }

  return now.getTime() - aggregatedAtMs >= LOCATION_SUMMARY_REFRESH_COOLDOWN_MS;
}
